import { Component, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { SingleActionCellRendererParams } from '../../../../../core/models/grid/single-action-cell-renderer-params';
import { FormControl } from '@angular/forms';
import { MatSelect } from '@angular/material/select';
import { FormCellRendererBaseComponent } from '../form-cell-renderer-base/form-cell-renderer-base.component';
import { MatButtonModule } from '@angular/material/button';

@Component({
    selector: 'app-single-action-cell-renderer-base',
    imports: [MatButtonModule],
    changeDetection: ChangeDetectionStrategy.Eager,
    templateUrl: './single-action-cell-renderer-base.component.html',
})
export class SingleActionCellRendererBaseComponent extends FormCellRendererBaseComponent<SingleActionCellRendererParams> {
    @ViewChild('inputElement') inputElement!: MatSelect;

    agInit(params: SingleActionCellRendererParams): void {
        this.params = params;

        this.formControl = params.context.formArray
            .at(params.node.rowIndex)
            .get(params.column?.getColId()) as FormControl;
    }

    onClick(): void {
        this.params.action(this.params);
    }

    onFocus(): void {
        if (this.shouldFocus()) {
            this.inputElement.focus();
            this.isFocusedState.set(true);
        }
    }
}
